import ProductInfo from "types/ProductInfo";
import Bloqueio from "../types/Bloqueio";

/**
 * Calcula a quantidade máxima que pode ser adicionada ao pedido
 * considerando estoque disponível e bloqueios
 */
export const calculateMaxQuantity = (
  qtd: number,
  infos: ProductInfo,
  bloqueio?: Bloqueio | null | undefined
): number => {
  let maxQtd = qtd;

  const availableStock = infos.qt_fisica - infos.qt_reservada;
  if (maxQtd > availableStock) {
    maxQtd = availableStock;
  }

  if (bloqueio) {
    const availableByBlock =
      bloqueio.qt_limita_venda - bloqueio.qt_pedido_dia - bloqueio.qt_vendida;
    if (maxQtd > availableByBlock) {
      maxQtd = availableByBlock;
    }
  }

  return maxQtd;
};
